import { render, staticRenderFns } from "./Pobocky.vue?vue&type=template&id=48003618&scoped=true&"
import script from "./Pobocky.vue?vue&type=script&lang=js&"
export * from "./Pobocky.vue?vue&type=script&lang=js&"
import style0 from "./Pobocky.vue?vue&type=style&index=0&id=48003618&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48003618",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/opt/atlassian/pipelines/agent/build/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
installComponents(component, {VFlex,VLayout,VSelect})
